import React from 'react';
import styled from 'styled-components';
import { AddFormToMatterModal } from '../add-to-matter-modal';

export function AddToMatterButton({ form }) {
  const [modalVisible, setModalVisible] = React.useState(false);

  const handleClick = React.useCallback(
    e => {
      setModalVisible(true);
    },
    [setModalVisible],
  );

  const closeModal = React.useCallback(() => {
    setModalVisible(false);
  }, [setModalVisible]);

  return (
    <>
      <StyledAddToMatterButton onClick={handleClick} type="button">
        <i className="fas fa-archive" />
        Add to Matter
      </StyledAddToMatterButton>

      {modalVisible && (
        <AddFormToMatterModal
          form={form}
          visible={modalVisible}
          closeModal={closeModal}
        />
      )}
    </>
  );
}

const StyledAddToMatterButton = styled.button`
  background: white;
  color: var(--COLOR_NICE_BLUE);
  border-radius: 3px;
  font-family: 'Zilla Slab', serif;
  font-size: 14px;
  font-weight: bold;
  max-width: 270px;
  padding: 9px 11px;
  text-align: center;
  width: 100%;
  margin-top: 12px;
  i {
    margin-right: 6px;
  }
`;
